import type { PresetMap } from '@splunk/dashboard-types';

import datasourcePresets from './DatasourcePresets';
import eventHandlerPresets from './EventHandlerPresets';
import inputPresets from './InputPresets';
import vizPresets from './VisualizationPresets';
import layoutPresets from './LayoutPresets';

export default {
    ...layoutPresets,
    ...datasourcePresets,
    ...eventHandlerPresets,
    ...inputPresets,
    ...vizPresets,
} as PresetMap;
